import twLocale from 'element-ui/lib/locale/lang/zh-TW'
import school_zhTw from './service/school_zhTw'
import hzmbG_zhTw from './service/HzmbG_zhTw';
import HzmbH_zhTw from './service/HzmbH_zhTw';
import HzmbChange_zhTw from "./service/HzmbChange_zhTw";
const ZH_TW = {
    message: {
        lang: 'ZH_HANT',
        lang_account: 'zh-hant',
        lan: 'Tc',
        lans: 'Cn',
        codeName: 'codeCname',
        doc_title: '交通事務局 網上服務',
        copyRight: '本網頁建議以 IE Edge+/Chrome/Firefox/Safari、1024×768像素以上瀏覽，以取得最佳瀏覽效果',
        select_file: '選擇文件',
        reupload: '重新上傳',
        apply_success: '申請成功',
        get_phone_code: '獲取驗證碼',
        verify_submit: '提交驗證',
        account_submit: '一戶通驗證',
        submit_success: '提交成功',
        afterFile: '立即補交',
        self_write: '重新填寫',
        check_and_submit: '確認無誤並提交',
        fileName: '文件名：',
        male: '男',
        female: '女',
        second: '秒',
        search_spNo_error: '查詢編號錯誤',
        search_personal_tips: '請使用申請人之一戶通帳號登錄',
        form_error: '欄位填寫有誤，請檢查！',
        confirm: '確認',
        cancel: '取消',
        upload_extensions_tips_part1: '請上傳後綴名為',
        upload_extensions_tips_part2: '的文件',
        upload_extensions_tips: '請上傳後綴名為{0}的文件',
        upload_maxSize_tips: '此文件不能超過',
        tips: '提示',
        confirm_delete: '確認刪除嗎？',
        save: '儲存',
        rules: '使用規章',
        guide: '用戶指南',
        agree: '同意',
        disagree: '不同意',
        before_filling: '您需要提前準備以下文件，否則可能會影響服務的申請',
        ready_to_filling: '已準備好，開始填寫資料',
        back: '返回',
        delete: "刪除文件",
        getCode_first: '請先獲取驗證碼',
        support_files_part1: '支持',
        support_files_part2: '格式上傳，文件大小不超過',
        file_empty: '未有文件上傳',
        close: '關閉',
        captcha: '驗證碼',
        captcha_plc: '請輸入驗證碼',
        validate_type: '驗證方式',
        notOnline1: '此服務將在',
        notOnline2: '上線',
        offline: '服務已下線',
        maintenance: '此服務將在',
        maintenance2: '進行維護',
        maintenance_tips1: '此服務正在維護',
        maintenance_tips2: '，維護時間：',
        maintenance_img_tips: '維護中',
        view_sample: '查看樣本',
        no_desired_result: '沒有想要的結果，',
        manual_input: "手動輸入",
        back_to_address_search: '返回街道/大廈名稱搜索',
        supplementReason: '不通過原因：',
        companyTypeCO: '自然人商業企業主(CO)',
        companyTypeEM: '商業企業(EM)',
        companyTypeSO: '法人商業企業主(SO)',
        accountLoginFailed: '一戶通登入異常，請重試',
        upload_required: '缺少必須提交文件，請檢查',
        upload_required_tips: "必須提交文件",
        termsTitle: '使用規章',
        termsTitle2: '使用條款',
        spNo: '查詢編號',
        spNo_placeholder: '請輸入查詢編號',
        spNoAndMobileFirst: '請輸入查詢編號及本澳流動電話',
        online_service: '交通事務局\n網上服務',
        online_service_mobile: '交通事務局\n網上服務',
        confirm_submit_content: '確認提交嗎？',
        macau_vehicle: '澳門車輛資料',
        hk_vehicle: '香港車輛資料',
        mainland_vehicle: '內地車輛資料',
        download: '下載',
        guide_title1: '個人配額內地報備續期',
        guide_title2: '公司配額內地報備續期',
        guide_title3: '查看辦理進度及補交文件',
        guide_title4: '個人配額提交申請文件',
        guide_title5: '公司配額提交申請文件',
        guide_title6: '的士駕駛員證繳付年度費用',
        guide_title7: '駕駛教練員准照續期',
        guide_title8: '駕駛學校校長准照續期',
        guide_title9: '駕駛學校執照續期',
        guide_title10: '澳門配額續期(個人配額)',
        guide_title11: '澳門配額續期(公司配額)',
        guide_title12: '香港貨車停泊澳門跨境貨物轉運站-新申請',
        guide_title13: '香港貨車停泊澳門跨境貨物轉運站-提交保險資料',
        guide_title14: '澳門貨車往來港澳-新申請(個人車主)',
        guide_title15: '澳門貨車往來港澳-新申請(公司車主)',
        guide_title16: '澳門貨車往來港澳-預約「指定日子許可」',
        companyBrNo_tooltips: '例：登記編號 SO 1234，只需輸入1234 便可',
        taxiCertNo: '的士駕駛員證編號',
        taxiCertNo_plh: '請輸入的士駕駛員證編號',
        statusZ: '狀態',
        statusA: '有效',
        statusB: '中止',
        statusC: '註銷',
        statusE: '失效',
        reLogin: '登錄時間過長，請重新登錄',
        copy: '複製',
        copy_success: '複製成功',
        copy_failed: '複製失敗',
        pay_success: '我已成功支付',
        closeDialog_in_seconds: '',
        closeDialog_in_seconds1: 's後自動關閉',
        pay_dialog_title: '請問是否已支付？',
        upload: '上傳',
        frontSide: "正面",
        reverseSide: "反面",
        macau_driver_no: '澳門駕駛執照編號',
        macau_driver_no_plh: '請輸入澳門駕駛執照編號',
        idType: '身份證明文件類別',
        idNo: '身份證明文件編號',
        idNo_plh: '請輸入身份證明文件編號',
        idType_macau: '澳門特別行政區身份證',
        idType_other: '其他',
        afterFile_success: '文件補交成功',
        upload_success: '上傳成功',
        identityNo_tooltips: '無需填寫/或(  )，例：12345670',
        must_macauMobile_login: '茲由於閣下於一戶通未有登記本澳流動電話，請重新選擇使用手機號登錄本系統。',
        canNotPay: '繳費失敗',
        reason: '原因：',
        imgEdit: '圖片編輯',
        enlarge: '放大',
        narrow: '縮小',
        need_authentication_tips: '*請確認資料無誤並進行活體檢測',
        need_authentication: '需要進行面活體檢測，點確認進行認證',
        authentication_failed: '活體檢測失敗，請重試！',
        authentication_status: '認證狀態：',
        authentication_status_no: '活體檢測失敗，點擊重新驗證',
        authentication_status_pass: '認證成功',
        confirm_submit: '確認提交',
        logout_account: '一戶通登出',
        ACCOUNT_MISMATCHED: '帳號不匹配，請登出重新查詢',
        canNot_afterFile: '無法進行補交',
        MPAY: 'MPay',
        GOV_PAY: '政付通',
        CEP: 'CEP',
        different_login_type: '數據異常，將自動跳回主頁，請重新選擇服務',
        backToHome: '正在返回首頁',
        hzmbFirstAgree: "確定同意為處理有關申請，交通事務局與相關行政當局（包括內地、香港、澳門的相關行政當局）可根據第8/2005 號法律《個人資料保護法》的規定，以包括資料互聯在內的任何方式，互相提供、交換、確認及使用涉及利害關係人的車輛、車主及駕駛員等的個人資料。",
        agree_statement: "所有現有及新指定的駕駛員必須知悉並同意行駛港珠澳大橋駕駛員之聲明及規定",
        DSAT0051: "通行限制車輛之特別許可申請",
        DSAT0046: "行人專用區的特別通行許可證",
        DSAT9037: "舊掛車/半掛車（拖架）臨時註冊",
        epay_ICRenewal: "車輛使用牌照稅",
        epay_ICRenewal_guide: "車輛使用牌照稅",
        epay_Cert_004: '駕駛執照證明',
        epay_Cert_005: '車輛資料證明',
        redCircleTips: "請參考下圖紅圈位置",
        tempSave_tips: "資料將於按[下一步] 時被保存",
        insuranceStartDateTips: "車輛的香港及內地保險證明文件 (關於保險的生效期可參考“常見問題”第15條)",
        vehicle_service_title: "車輛服務",
        lic_service_title: "駕駛執照服務",
        other_service_title: "其他服務",
        registrationNo_tips: "駕駛員必須具備相應“手動變速車輛”駕駛資格",
        hzmbMoRenew: {
            amount: "單價",
            taxAmount: "稅率",
            totalAmount: "合計",
            terms: "聲明：本人知悉及同意應遵事項之內容",
            terms_title: "條款",
            terms_agree: "請勾選聲明",
            payment_success_personal: "已繳付澳門私家車往來港澳常規配額 澳門配額續期（個人配額）之費用 \n個案查詢編號: {0}",
            payment_success_company: "已繳付澳門私家車往來港澳常規配額 澳門配額續期（公司配額）之費用 \n個案查詢編號: {0}",
            hzmbMoTerms: "<p>" +
                "  應遵事項：" +
                "  <br />" +
                "</p>" +
                "<ul>" +
                "  <li>每一配額均可配備不多於三名指定駕駛員，指定駕駛員須持有有效澳門居民身份證及由澳門當局發出的證明其具相關駕駛資格的澳門駕駛執照或特別駕駛許可證。公司配額指定駕駛員必須為公司的持有人或其屬下員工，並須提交有關的證明文件（如公司商業登記證明或由公司負責人簽名及公司蓋章的員工在職證明文件等）；個人配額申請人必須為指定駕駛員，但年齡達70歲或以上之申請人可無需作為指定駕駛員。</li>" +
                "  <li>如需更換使用配額的車輛（下稱“配額車輛＂）、車輛註冊號碼或駕駛員，每項資料的更改將收取費用（澳門元$1,000），不論在任何情況下，所有已支付的費用將不予退還。</li>" +
                "  <li>配額有效期內，有關公司不可一次或多次累計移轉該公司資本超過百分之五十，否則，將取消有關配額，但因繼承而作出移轉的情況則不在此限。</li>" +
                "  <li>不得連續超過180日處於未有向本局指定配額車輛或指定配額車輛被取消註冊的狀態，否則，將取消有關配額。</li>" +
                "  <li>配額不得轉讓，如車輛所有人在配額有效期內更改為另一所有人（配額持有人不再是配額車輛的所有人），以及2.3點所述情況，有關配額將會被取消。</li>" +
                "  <li>配額車輛須為配額持有人在澳門註冊登記為私人用途的輕型客車，而為符合香港的法例要求，由首次登記日期起計車齡達六年或以上的車輛必須在每年辦理「過境車輛封閉道路通行許可證」及「國際通行許可證」前於澳門通過檢驗；配額持有人亦必須確保配額車輛於行駛港珠澳大橋時持有三地有效車輛強制保險。</li>" +
                "  <li>配額車輛和其指定駕駛員須遵守港澳相關法例規定。此外，由於大橋主橋位於內地司法管轄區，配額車輛及駕駛員在大橋主橋行駛時，須遵守內地法例及內地對來往港澳但不入境珠海車輛的規定。</li>" +
                "  <li>具備有效配額、香港運輸署發出的有效「過境車輛封閉道路通行許可證」（CRP）和「國際通行許可證」（ICP）、澳門海關發出的有效「車輛邊境通行證」和「車輛通關電子標籤」（RFID），以及內地發出的有效「臨時機動車駕駛許可」和「臨時入境機動車行駛證」及三地有效保險的配額車輛，可行駛港珠澳大橋往來港澳兩地，任何人或公司須自行對因其自身、內地或香港的原因導致其配額車輛未能經港珠澳大橋往來港澳兩地的情況及有關後果負責。</li>" +
                "  <li>配額持有人、指定駕駛員或配額車輛如違反申領配額及港澳有關牌證的條款，其有關配額或牌證可被取消，其配額或牌證申請亦將不予受理。如配額、牌證或入境資格被取消，相應的配額及牌證亦可被取消。</li>" +
                "  <li>如內地根據內地規定取消有關車輛或申請人的入境資格，其相關配額及牌證可被取消，其配額及牌證申請亦將不予受理。</li>" +
                "  <li>同一配額持有人只可於同一期間持有私家車往來港澳的澳門配額或香港配額，若於同一期間被發現同時持有私家車往來港澳的澳門配額及香港配額，其配額可被取消，其日後的配額及牌證申請亦將不予受理。</li>" +
                "  <li>如發現配額持有人及指定駕駛員曾利用配額車輛進行走私、運送他人偷越邊境、非法營運（包括“白牌車”）、違規攜帶禁止或限制進出境物品、未申報應實施檢驗檢疫的行李或貨物等違法活動，該車輛相應的配額可被取消，而自查實確認之日起計三年內，配額持有人及行為人的配額及牌證申請亦將不予受理。</li>" +
                "  <li>如發現配額持有人曾以欺騙等不正當手段獲取港澳跨境私家車牌證，其配額可被取消，而自查實確認之日起計三年內，其配額及牌證申請將不予受理。</li>" +
                "  <li>申請人及配額持有人所填寫及提交的一切資料均須屬實，並無虛訛，否則其申請將不予受理或其配額可被取消，而自查實確認之日起計三年內，其申請將不予受理，以及可被追究相應的刑事責任。</li>" +
                "  <li>如配額車輛無正當理由逾期離港或無法離港，自離港或查實確認之日起計三年內，配額持有人及行為人的配額及牌證申請將不予受理。</li>" +
                "  <li>如發現配額車輛曾超出通行區、通行條件或由非指定駕駛員駕駛，自查實確認之日起計一年，配額持有人及行為人的配額及牌證申請將不予受理。</li>" +
                "  <li>經澳門海關張貼在配額車輛的「車輛通關電子標籤」（RFID），在配額有效期間不得任意移除，違反者將可被視作超出通行條件處理。</li>" +
                "  <li>如發現配額車輛在未有遵循“澳車北上”的預約規則下進入內地，首次違反，該車輛相應的配額可被中止效力一個月，續後的每次違反，該車輛相應的配額可被中止效力三個月。</li>" +
                "</ul>" +
                "<p></p>",
        },
        Booking: {
            success: "成功",
            CONFIRMED: "生效中",
            CANCELED: "已取消",
            EXPIRED: "已過期",
            CANCELED90: "已取消（90日内）",
            EXPIRED90: "已過期（90日内）",
            maintenanceTitle: "提示",
            maintenanceMessage: "該業務在 {0} - {1} 進行維護：{2}",
            maintenanceMessageOffShelf: "該業務已下線",
            maintenanceMessageBefore: "該業務將於 {0} - {1} 進行維護：{2}",
            bookingService: "預約業務",
            myInfo: "我的信息",
            disabledInfo: "禁止預約信息",
            myBooking: "我的預約申請（每1次預約可通關1次）",
            addBooking: "新增預約申請",
            updateTitle: "修改預約申請",
            confirmInfoTitle: "請確認預約信息",
            selectBookingTitle: "請選擇預約日期",
            selectBtn: "選擇",
            unlimited: "不限額",
            haveQuota: "有配額",
            noQuota: "無配額",
            isBooking: "是否預約{0}？",
            confirmAppDate: "確認預約日期",
            bookingDate: "預約日期：",
            forbidBookingDate: "禁止預約日期範圍",
            forbidBookingCause: "禁止預約原因",
            bookingPhone: "預約電話",

            addBtn: "新增預約",
            updateBtn: "修改預約",
            initBtn: "返回我的預約",
            cancelBtn: "取消預約",
            logoutBtn: "退出登入",
            viewAllBtn: "查看所有預約",
            confirmBtn: "確認預約",
            bookingBtn: "預約",
            returnBtn: "返回我的預約",
            confirmCancel: "確認取消",

            applicantIdentType: "登記類型",
            applicantIdentNo: "登記編號",
            regAndIdNo: "車牌編號",
            mobile: "本澳流動電話",
            cancelable: "本月可取消次數（剩餘/最多）",
            selectBooking: "當前選擇的預約：",
            applicationDate: "申請時間",
            cancelDate: "取消日期",
            applicationNo: "預約編號",
            companyTypeCO: '自然人商業企業主(CO)',
            companyTypeSO: '法人商業企業主(SO)',
            companyTypeBM: '澳門特別行政區身份證',

            notData: "暫無預約記錄",
            notBookingDate: "暫無預約日期",
            isCancelTip: "是否確認取消預約",
            cancelText: "是否取消 {0} 的預約？",
            isSaveTip: `將本次輸入的資料儲存在本裝置內，供下次開啟時使用；<span class="colorRed">如本裝置非私人物品，不建議儲存，以減少個人資料外洩的風險！注：某些機型或在無痕模式執行可能無法儲存。</span>`,
            isSaveArr: {
                yes: "同意儲存",
                no: "不同意儲存"
            },
            weeks: {
                Sunday: "週日",
                Monday: "週一",
                Tuesday: "週二",
                Wednesday: "週三",
                Thursday: "週四",
                Friday: "週五",
                Saturday: "週六"
            },
            results: {
                success: "預約成功",
                error: "預約失敗",
                cancel: "預約已取消",
                reason: "原因：",
            },
        },
        DataRegistration: {
            formData: {
                owner_data: '配額人資料',
                vehicle: '車輛資料',
                drivers_data: '駕駛員資料',
                cheque_data: '支票資料',
                no: '第',
                driver: '駕駛員',
                driver_de: '駕駛員的',
                add_drivers: '新增駕駛員',
                next: '下一步：上傳文件',
                input_drivers: '把配額人資料自動填寫至',
                nothing: '不使用',
                baseData: '基本資料',
                payment_info: '繳費信息'
            },
            upload: {
                already_upload_file: '已上傳文件：',
                next: '下一步：檢查確認',

            },
            check: {
                already_data: '已錄入資料',
                owner_data: '配額人資料',
                already_upload_file: '已上傳文件',
                submit: '確認無誤並提交'
            },
            Quota: {
                idType: '配額人的證件類別',
                personNameCn: '配額人的中文姓名',
                personNameEn: '配額人的外文姓名',
                personIdentityNo: '配額人的澳門居民身份證編號',
                personBirthday: '配額人的出生日期',
                companyNameCn: '配額公司的商業登記名稱（中文）',
                companyNameEn: '配額公司的商業登記名稱（外文）',
                companyBrNo: '配額公司的商業登記編號',
                companyIdentityType: '配額公司的商業登記類型',
                personNameCn_plh: '請輸入配額人的中文姓名',
                personNameEn_plh: '請輸入配額人的外文姓名',
                personIdentityNo_plh: '請輸入配額人的澳門居民身份證編號',
                personBirthday_plh: '請輸入配額人的出生日期',
                companyNameCn_plh: '請輸入配額公司的商業登記名稱（中文）',
                companyNameEn_plh: '請輸入配額公司的商業登記名稱（外文）',
                companyBrNo_plh: '請輸入配額公司的商業登記編號',
                companyIdentityType_plh: '請輸入配額公司的商業登記類型',
                macauMobile: '配額人的本澳流動電話',
                otherPhone: '配額人的其他聯絡電話',
                mainlandPhone: '配額人的內地聯絡電話',
                mainlandEmail: '配額人的內地電郵地址',
                hkPhone: '配額人的香港聯絡電話',
                hkAddress: '配額人的香港聯絡地址',
                personal_macauMobile_plh: '請輸入配額人的本澳流動電話',
                personal_otherPhone_plh: '請輸入配額人的其他聯絡電話',
                personal_mainlandPhone_plh: '請輸入配額人的內地聯絡電話',
                personal_mainlandEmail_plh: '請輸入配額人的內地電郵地址',
                personal_hkPhone_plh: '請輸入配額人的香港聯絡電話',
                personal_hkAddress_plh: '請輸入配額人的香港聯絡地址',
                personal: "配額人的",
                company: '配額公司的'
            },
            Driver: {
                nameCn: '中文姓名',
                nameEn: '外文姓名',
                identityNo: '澳門居民身份證編號',
                sex: '性別',
                birthday: '出生日期',
                nationality: '國籍',
                other_nationality: '其他國籍',
                macauDrivingLicenseType: '澳門駕駛文件類別',
                macauDrivingLicenseNo: '澳門駕駛文件編號',
                // macauAddress
                macauMobile: '本澳流動電話',
                mainlandPhone: '內地聯絡電話',
                mainlandEmail: '內地電郵地址',
                mainlandDrivingLicenseNo: '內地駕照編號',
                mainlandDrivingPermitNo: '內地駕駛許可檔案編號',
                nameCn_plh: '請輸入中文姓名',
                nameEn_plh: '請輸入外文姓名',
                identityNo_plh: '請輸入澳門居民身份證編號',
                sex_plh: '請輸入性別',
                birthday_plh: '請輸入出生日期',
                nationality_plh: '請輸入國籍',
                other_nationality_plh: '請輸入其他國籍',
                macauDrivingLicenseType_plh: '請輸入澳門駕駛文件類別',
                macauDrivingLicenseNo_plh: '請輸入澳門駕駛文件編號',
                macauMobile_plh: '請輸入本澳流動電話',
                mainlandPhone_plh: '請輸入內地聯絡電話',
                mainlandEmail_plh: '請輸入內地電郵地址',
                mainlandDrivingLicenseNo_plh: '請輸入內地駕照編號',
                mainlandDrivingPermitNo_plh: '請輸入內地駕駛許可檔案編號',
                change_drivers_tips1: '變更選項將清空第',
                change_drivers_tips2: '駕駛員資料，是否繼續?',
                update_drivers_data: '更新駕駛員資料',
                no_update_tips: '如駕駛員資料沒有更新，可不用填寫。'
            },
            Cheque: {
                tips: '註：',
                tips1: '1. 收款人為「香港特別行政區政府」;',
                tips2: '2. 銀行或會收取相應的手續費用。',
                bank: '支票或滙票的發出銀行',
                amount: '支票金額HKD',
                no: '支票號碼',
                bank_plh: '請輸入支票或滙票的發出銀行',
                amount_plh: '請輸入支票金額HKD',
                no_plh: '請輸入支票號碼',
                refer: '支票號碼請參考下圖紅圈位置'
            },
            Vehicle: {
                registrationNo: '車輛的註冊編號',
                registNoAndIdNo: '車輛的註冊編號',
                registNoAndIdNo_plh: '請輸入車輛的註冊編號',
                identificationNo: '車輛的車身編號最後8個字元',
                hkInsuranceCompany: '發出香港保險單的保險公司名稱',
                hkInsuranceNo: '車輛的香港保險單編號',
                hkInsuranceStartDate: '車輛的香港保險單生效日期',
                hkInsuranceEndDate: '車輛的香港保險單結束日期',
                mainlandInsuranceNo: '車輛的內地保險單編號',
                mainlandInsuranceStartDate: '車輛的內地保險單生效日期',
                mainlandInsuranceEndDate: '車輛的內地保險單結束日期',
                mainlandRegistrationNo: '車輛於內地登記車牌編號',
                registrationNo_plh: '請輸入車輛的註冊編號',
                identificationNo_plh: '請輸入車輛的車身編號最後8個字元',
                hkInsuranceCompany_plh: '請輸入發出香港保險單的保險公司名稱',
                hkInsuranceNo_plh: '請輸入車輛的香港保險單編號',
                hkInsuranceStartDate_plh: '請輸入車輛的香港保險單生效日期',
                hkInsuranceEndDate_plh: '請輸入車輛的香港保險單結束日期',
                mainlandInsuranceNo_plh: '請輸入車輛的內地保險單編號',
                mainlandInsuranceStartDate_plh: '請輸入車輛的內地保險單生效日期',
                mainlandInsuranceEndDate_plh: '請輸入車輛的內地保險單結束日期',
                mainlandRegistrationNo_plh: '請輸入車輛於內地登記車牌編號',
                registrationNo_tips: '例:MA-01-23 只需輸入 MA0123 便可',
                identificationNo_tips: '請參考下圖所示登記摺上車身編號位置',
                identificationNo_mark1: '註:「/」、「-」、「*」、「.」或空格無需輸入',
                identificationNo_mark2: '例: 車身編號 *WDB202020 2F 123456*',
                identificationNo_mark3: '只需輸入 3456 便可',
                identificationNo_plh2: '1. 請輸入「車牌編號」',
                identificationNo_last4_plh: '2. 請輸入「車身編號」的最後4個字元',
            },
            VSS: {
                applyReason: '所符合的申請資格條件',
                moCorpDate: '澳門公司開業日期',
                hkCorpNo: '香港公司商業登記編號',
                hkCorpName: '香港公司商業名稱',
                hkCorpDate: '香港公司開業日期',
                applyReason1: '在香港持有物業',
                applyReason2: '在香港從事受薪工作',
                applyReason3: '在香港開設公司',
            },
            Taxi: {
                nameTc: '中文姓名',
                nameEn: '外文姓名',
                status: '狀態',
                issueDate: '發證日期',
                expiredDate: '有效日期',
                payment_describe: '繳付項目描述',
                payment_status: '繳付狀態',
                no_payment: '未繳付',
                payment_paid: '',
                amount: '年度費用',
                taxAmount: '稅金',
                payment: '繳付方式',
                mPay: 'MPay',
                notice: '繳費通知',
                macauMobile: '本澳流動電話：',
                email: '電子郵件（可選）：',
                email_plh: '請輸入電子郵件',
                email_again_plh: '請再次輸入電子郵件',
                payment_btn: '立即繳付',
                paid: '已繳付本年之年度費',
                showRecord: '查看歷年繳付年度費記錄',
                record: '歷年繳付年度費記錄',
                canNotPay: '無法繳付年度費用',
                reason: '原因：',
                payment_success: '已繳付本年年度費用',
                failed_tips: '如需查詢，可於辦公時間內致電交通事務局熱線88666363。',
                year: '年度',
                total: '繳付總額',
                payment_date: '繳付日期',
                showAll: '顯示全部',
                pay_way: '請選擇其中1種方式進行支付',
                pay_way1: '方式1：點擊按鈕，直接打開「MPay Web」',
                pay_way2: '複製鏈接到手機瀏覽器，打開「MPay App」',
                pay_way1_btn: '打開 MPay Web',
                email_notice_tips: '若錄入電郵地址，繳付費用後將會收到電郵通知',
                copy_link: '複製鏈接',
                paid_tips: '完成支付後，點擊以下按鈕查看支付結果。',
                spNo: '個案查詢編號',
            },
            International: {
                baseInfo: '申請人基礎信息',
                macau_driver_type: '澳門駕駛執照類別',
                macau_driver_no_date: '澳門駕駛執照有效期至',
                surname: '姓',
                // surname_cn:'中文姓',
                name: '名',
                // name_cn:'中文名',
                birthday: '出生日期',
                birthPlace: '出生地',
                // birthPlace_cn:'出生地中文',
                idType_cn: '證件類型中文',
                checkRecord: '查看過往申請記錄',
                checkRecordTitle: '過往申請記錄',
                infoTips: '上述資料如有不符，請到交通事務局服務專區辦理資料更新。',
                submitTitle: '提交申請文件',
                internationalLicenseExpiredDate: '本次申請國際駕照有效期至',
                internationalAddress: "國際駕照領證地點",
                mobile: "本澳流動電話(用於短訊通知)",
                language: "語言",
                notice: '注意事項',
                question1: '交通事務局將「{0}」的通知短訊（SMS）發至本人駕駛員檔案內登記的本澳流動電話號碼；',
                question2_text: '本人同意以上所填之資料將作為個人駕駛員檔案資料。',
                agree: '同意',
                disagree: '不同意',
                known: '已知悉',
                iscorrect: '否，上述資料有誤',
                update_tips: '請到交通事務局服務專區辦理資料更新',
                select_upload_type: '請選擇上傳方式',
                upload_by_self: '自已上傳',
                upload_by_studio: '通過合作照相館上傳',
                imageCode_plc: '請輸入照片識別碼',
                next_check: "下一步：覆核資料",
                next_pay: '下一步：繳費',
                payment_info: '繳費信息',
                payment_total: '申請費用',
                payment_type: '繳付方式',
                payment_tips: '* 確認繳費後，將無法返回修改資料，只能重新提交申請。請確認資料無誤後再進行繳費。',
                back_to_fill: '返回重新填寫',
                confirm_and_pay: '確認資料並繳費',
                licenseNo: '國際駕照編號',
                createDay: '發出日期',
                expiryDate: '有效日期',
                applyDate: '申請日期',
                sendDate: '領取日期',
                spNo: '個案查詢編號',
                zoneName: '申請途徑',
                apply_success: '申請提交成功',
                inputStudioCode: '請輸入相片識別碼',
                canNotApply: '無法申請國際駕照',
                continue_pay: '認證成功，繼續支付',
                authentication_reson: '國際駕駛執照申請',
                device_deff_tips: "本次服務提供之本澳流動電話/語言偏好與台端於本局駕駛員檔案內之資料 ({0} / {1}) 不同，本人已知悉以上所填之資料將作為個人駕駛員檔案資料。",
                device_data: "駕駛員檔案內登記之資料",
                payment_notice: "(付款後將透過此電郵收到確認繳費通知)",
                email: '電子郵件（僅用於本次服務通知）：',
                confirm_title: "資料確認"
            }
        },
        Verification: {
            personal: {
                onePass_verify: '一戶通登錄驗證',
                phone_verify: '手機號登錄',
                id_no: '澳門居民身份證編號',
                id_placeholder: '請輸入澳門居民身份證編號',
            },
            company: {
                macau_company_type: '配額公司的商業登記類型',
                macau_company_type_plh: '請輸入配額公司的商業登記類型',
                companyBrNo: '配額公司的商業登記編號',
                companyBrNo_plh: '請輸入配額公司的商業登記編號',
            },
            mobile: '本澳流動電話(用於短訊通知)',
            mobile_placeholder: '請輸入本澳流動電話',
            input: '請輸入',
            phone_code: '手機驗證碼',
            phone_code_placeholder: '請輸入手機驗證碼'
        },

        macauAddress: {
            quotaMacauAddress: "配額人的澳門聯絡地址",
            macauAddress: '澳門聯絡地址',
            macauAddress_plh: '請輸入澳門聯絡地址',
            phase: '期',
            room: '座(室)',
            room2: '座',
            dialog_title: '配額人的澳門聯絡地址',
            block: '座(棟)',
            block2: '座',
            address: '地址',
            doorPlate: '地段/門牌編號',
            doorPlate2: '號',
            floor: '樓',
            address_plh: '請輸入關鍵字匹配街道/大廈名稱',
            manual_address_plh: '請輸入地址',
            street_or_building: '街道/大廈名稱',
            street_name: '街道/大廈名稱',
            back_to_search: '返回街道/大廈名稱搜索',
            building_name: '大廈/屋苑名稱',
            building_name_plh: '請輸入關鍵字匹配大廈/屋苑名稱',
            tips: '大廈座別 - 單位樓層 - 單位座別：',
            no: '第',
            doorPlate_plh: '請輸入地段/門牌編號',
            area: '地區',
            area_macau: '澳門',
            area_taipa: '氹仔',
            area_coloane: '路環',
            num: ''
        },
        entries: {
            home: {
                one: '澳門私家車\n往來港澳常規配額',
                two: '港澳跨境客運',
                three: '的士駕駛員證\n綜合服務',
                four: '駕駛執照服務',
                five: "駕駛學校及教練員服務",
                hzmbTruck: "港澳跨境貨運",
                hzmbH: "澳門貨車往來港澳",
            },
        },
        status: {
            SUBMITTED: '提交成功',
            FOLLOWING: '申請時提交文件有誤，請點擊按鈕補交',
            PRE_APPROVED: '預審通過',
            NOT_APPROVED: '預審不通過，原因如下：',
            APPROVED: '你的申請已審批通過',
            REJECTED: '審批不通過，原因如下：'
        },
        formRuleMessage: {
            notNull: '不能為空',
            maxLength6: '長度在6個字符內',
            maxLength8: '長度在8個字符內',
            maxLength10: '長度在10個字符內',
            maxLength20: '長度在20個字符內',
            maxLength21: '長度在21個字符內',
            maxLength26: '長度在26個字符內',
            maxLength30: '長度在30個字符內',
            maxLength50: '長度在50個字符內',
            maxLength100: '長度在100個字符內',
            maxLength200: '長度在200個字符內',
            changeDate: '請選擇日期',
            hkInsuranceEndDateCheck: '車輛的香港保險單結束日期必須大於270天',
            mainlandInsuranceEndDateCheck: '車輛的內地保險單結束日期必須大於等於今天',
            macauMobile: '請輸入正確流動電話號碼',
            olderThan18: '駕駛員必須年滿18歲',
            macauDrivingLicenseCheck: '駕駛員之澳門駕駛文件類別+澳門駕駛文件編號不可相同',
            email: '請輸入正確的電郵地址',
            must_be_number: '請輸入正確流動電話號碼',
            either_or_companyNameCn_companyNameEn: '（請在”配額公司的商業登記名稱(中文)”或” 配額公司的商業登記名稱(外文)”中選擇一個填寫）',
            either_or_mainlandPhone_mainlandEmail: '（請在”配額人的內地聯絡電話”或”配額人的內地電郵地址”中選擇一個填寫）',
            either_or_mainlandPhone_mainlandEmail_drivers: '（請在“駕駛員的內地聯絡電話”或“駕駛人的內地電郵地址”中請選擇一個填寫）',
            companyNo: '請輸入正確澳門商業登記編號',
            taxi_email: '請再次輸入電郵地址',
            taxi_email_confirm: '請確保兩次輸入的電郵地址一致',
            identityNo: '請輸入正確的澳門居民身份證編號',
            taxiCertNo: '請輸入正確的的士駕駛員證編號',
            otherPhone: '請輸入正確的其他聯絡電話（數值(0-9)、"-"、","）',
            mainlandPhone: '請輸入正確的內地聯絡電話',
            hkPhone: '請輸入正確的香港聯絡電話（數值(0-9)、"-"）',
            payment_notNull: "必須選擇一種支付方式",
        },
        ErrorMessage: {
            ClientException: "客戶端異常，請重試",
            DataAbnormity: "數據異常，請重試",
            ServerException: "服務器異常，請稍後再試",
            NetworkException: "未知網絡異常，請重試",
            CheckNetwork: "請檢查網絡後重試",
            UnknownError: "未知錯誤",
            ACCESS_DENIED: '沒有權限',
            APPROVALING_APPLICATION: '(PAS-0009)閣下提供的查詢編號正在辦理服務',
            APPLICATION_UNKNOW: '(PAS-0015)服務申請異常，請聯絡交通事務局',
            DOCUMENT_TYPE_MUST_REQUIRED: '缺少必須提交文件，請返回上一步檢查',
            REQUEST_TOO_FREQUENTLY: '請求過於頻繁，一分鐘後再試',
            CAPTCHA_HAS_EXPIRED: '驗證碼已失效，請重新獲取',
            CAPTCHA_VERIFY_FAILED: '驗證碼驗證失敗，請重新獲取！',
            CAPTCHA_NOT_FOUND: '驗證碼不存在，請重新獲取',
            CHECKAPPLICANTDRAW: '查詢編號與申請人資料不符',
            PARAMETER_NOT_VALID: '參數無效',
            CAPTCHA_IS_MISMATCH: '驗證碼錯誤！',
            ILLEGAL_STATUS: '非法的狀態',
            SP_SERVICE_EXEC_FAILURE: '(PAS-0012)服務申請異常，請聯絡交通事務局',
            UNSUPPORTED_SERVICE_TYPE: '不支持的服務類型',
            OUTPUT_RESULT_IS_EMPTY: 'SP執行結果爲空',
            SERVICE_TYPE_NOT_FOUND: '(PAS-0014)服務申請異常，請聯絡交通事務局',
            DRIVER_NOT_FOUND: '司機不存在',
            NO_RESULT: '沒有結果',
            VSS_SERVICE_EXEC_FAILURE: '(PAS-0010)服務申請異常，請聯絡交通事務局',
            SESSION_IS_REQUIRED: 'session必須存在',
            MOBILE_MISMATCH: "(PAS-0001)閣下提供的查詢編號已使用另一流動電話提交申請",
            GATEWAY_TIME_OUT: '請求超時，請重試',
            SYSTEM_BUSY: '服務申請異常，請聯絡交通事務局',
            TAXI_CERT_NO_ERROR: '請輸入正確之的士駕駛員證編號',
            D02: "請輸入正確之澳門居民身份證編號",
            PAYMENT_TIME_TIME_OUT: '(PAS-0005)支付超時，請返回重新進入',
            REPEAT_PAYMENT_ERROR: '(PAS-0006)為避免重複繳付，\n請',
            REPEAT_PAYMENT_ERROR1: '後再次發起支付',
            MOBILE_IS_MISMATCH: '驗證碼錯誤！',
            ACCOUNT_MISMATCHED: '帳戶不匹配，請重試！',
            LIC_NO_NOT_BE_NULL: '請輸入澳門駕駛執照編號',
            PHOTO_NO_ERROR: '相片二維碼不存在!',
            DOWNLOAD_ERROR: '下載文件出錯!',
            COACH_APPLICATION_NOT_FOUND: '未找到駕駛教練員准照續期',
            HEAD_APPLICATION_NOT_FOUND: '未找到駕駛學校校長准照續期',
            SCHOOL_APPLICATION_NOT_FOUND: '未找到駕駛學校執照續期',
            PAYMENT_STATUS_ERROR: "支付失敗，請重新進入",
            DUPLICATE_APPROVING_APPLICATION: "閣下提供的香港車輛登記號碼已正在辦理服務",
            CHECK_FAIL: "准入未通過",
            FORBID_IDENTITY_TYPE: "未能通過服務審核條件 (證件類型不符)",
            "E-1077": "閣下提供之香港車輛登記號碼相關批文已失效",
            "E-1001": "查詢編號與申請人資料不符",
            "E-H001": "參數必填項不可為空",
            "E-H012": "沒有找到有效的批文",
            "E-H023": "此批文已經存在臨時狀態的續期或取消申請",
            "E-H013": "申請人信息不一致",
            GET_FEE_FAILURE: "(PAS-0013)服務申請異常，請聯絡交通事務局",
            SQL_ERROR: "(PAS-0016)服務申請異常，請聯絡交通事務局",
            SQL_NOT_NULL_ERROR: "(PAS-0017)檢測到必填項為空，請填寫後再提交申請，如情況持續出現，請聯絡交通事務局",
            SQL_ENCODING_ERROR: "(PAS-0018)檢測到不支援之字符，請更改後再提交申請，如情況持續出現，請聯絡交通事務局",
            // 換人換車
            CHANGE_PARSON_HAVE_SAME_ERROR: "新更換的駕駛員組合與現時的駕駛員組合完全相同，請重新提供駕駛員的資料或重新選擇適當的申請類型",
            // H類新申請
            DATA_EXCEPTION: "系统數據異常,車主證件類型與公司證件類型都為空",
            SAVE_FILE_STATUS_ERROR: "不是暫存狀態，無法保存",
            DOCUMENT_TYPE_UNKNOWN: "無效檔案類型",
            SERVICE_ONLINE: "非上線期間",
            SERVICE_MAIN_TENANCE: "服務維護中",
            SERVICE_FAILURE: "(PAS-0011)服務申請異常，請聯絡交通事務局",
            SYSTEM_TIMEOUT: "服務超時，請重試",
            FOLLOWING_FILE_STATUS_ERROR: "不是補交狀態，無法保存",
            SERVICE_TYPE_ERROR: "服務類型錯誤",
            APPLICATION_DOCUMENT_UNKNOW: "無需補交文件",
            SPNO_ERROR: "(PAS-0019)請關閉所有網頁分頁後，重新進入服務上傳文件，如情況持續出現，請聯絡交通事務局",
            // G類保險更新
            UPLOAD_ERROR: "(PAS-0007)上傳文件出錯，請重新操作，如情況持續出現，請聯絡交通事務局",
            IOException: "(PAS-0008)下載文件出錯，請重新操作，如情況持續出現，請聯絡交通事務局",
            CHECK_INSURANCE_UPD_FOR_G_ERROR:"保险准入出錯",
            USER_MOBILE_IS_NULL: "用户手機號為空",
            APPLICATION_STATUS_ERROR: "申請單狀態異常",
            MOBILE_IS_NULL: "手機號為空",
            REGISTER_TYPE_MAPPING_ERROR: "登記類型匹配失敗",
            // H類預約
            BUSINESS_NOT_FOUND: "業務不存在",
            PLAN_DURATION_NOT_FOUND: "無該計劃時段",
            OVER_BUSINESS_APPLACATION_TIMES: "一個電話號碼在一天內對該業務的預約次數已達到上限，不能繼續預約；該業務可預約最大次數是：{0}",
            OVER_BUSINESS_NUM: "一個電話號碼在一天內可預約業務數已達到上限，不能繼續預約同一天內的其他業務",
            APPLICATION_DETAILS_NOT_FOUND: "預約明細不存在",
            APPLICATION_NOT_FOUND: "(PAS-0004)服務申請異常，請聯絡交通事務局",
            APPLICATION_DETAILS_IS_REQUIRED: "預約明細必需填寫",
            BOOKING_DATE_ILLEGAL: "預約日期超出可預約範圍",
            PLAN_NOT_FOUND: "計劃不存在",
            DETAIL_TIME_HAVE_OVERLAP: "預約明細時段存在衝突",
            DURATION_ONLY: "業務時段已被預約",
            BREACH_APPLICATION_UPDATE_LIMIT: "當前預約記錄不可修改",
            BREACH_APPLICATION_CANEL_LIMIT: "當前預約記錄不可取消",
            APPROVAL_INFO_NULL: "信息驗證失敗，請檢查登記類型、登記編號及車牌編號是否正確",
            IN_MAINTENANCE_TIME: "系統業務處於維護時間",
            OVER_CANCEL_TIME: "不在可取消預約時間內",
            CANCEL_NUM_LIMIT: "超出可取消預約次數",
            OVER_BOOKING_TIME: "不在可預約時間內",
            OVER_CARNO_DAY_LIMIT: "同一車牌超出當天可申請次數",
            MOBILE_NOT_SAME: "登入電話和取消記錄電話不一致",
            TOKEN_ERROR: "token錯誤",
            TOKEN_EXPIRED: "token過期",
            RECEPTION_IS_FULL: "已達到接待人數上限",
            DSAJ_CHECK_NOT_ACCEPT: "(PAS-0003)閣下提供至查詢編號的申請人與指定配額車輛之車主不符"
        },
        router: {
            formData: '資料錄入',
            upload: '上傳文件',
            check: '檢查確認',
            verify_company: '公司身份驗證',
            verify_person: '個人身份驗證',
            entry: '澳門私家車\n往來港澳常規配額',
            entryBus: '跨境巴士及跨境出租車',
            entryTaxi: '的士駕駛員證繳付年度費用',
            verify_booking: '預約申請驗證',
            payment: "繳費",
        },
        capitalLetter: ['〇', '一', '二', '三', '四', '五', '六', '七', '八', '九', '十',
            '十一', '十二', '十三', '十四', '十五', '十六', '十七', '十八', '十九',
            '二十'
        ],
        terms_body: "<p>" +
            "1. 應遵事項" +
            "<br />" +
            "</p>" +
            "<ul>" +
            "  <li>每一配額均可配備不多於三名指定駕駛員，指定駕駛員須持有有效澳門居民身份證及由澳門當局發出的證明其具相關駕駛資格的澳門駕駛執照或特別駕駛許可證。公司配額指定駕駛員必須為公司的持有人或其屬下員工，並須提交有關的證明文件（如公司商業登記證明或由公司負責人簽名及公司蓋章的員工在職證明文件等）；個人配額申請人必須為指定駕駛員，但年齡達70歲或以上之申請人可無需作為指定駕駛員。</li>" +
            "  <li>獲發配額後，如需更換使用配額的車輛（下稱“配額車輛＂）、車輛註冊號碼或駕駛員，每項資料的更改將收取費用（澳門元壹仟元正），不論在任何情況下，所有已支付的費用將不予退還。</li>" +
            "  <li>屬排序名單中公司配額數量範圍內的公司自排序名單公佈日起至配額有效期屆滿之日止（替補公司則自其接獲本局通知替補之日起至配額有效期屆滿之日止），該公司不可一次或多次累計移轉該公司資本超過百分之五十，否則，將視為放棄其名額，並將按順序由下一排名的申請人替補或取消有關配額，但因繼承而作出移轉的情況則不在此限。</li>" +
            "  <li>獲發配額後，不得連續超過180日處於未有向本局指定配額車輛或指定配額車輛被取消註冊的狀態，否則，將取消有關配額。</li>" +
            "  <li>配額不得轉讓，如車輛所有人在配額有效期內更改為另一所有人（配額持有人不再是配額車輛的所有人），以及3點所述情況，有關配額將會被取消。</li>" +
            "  <li>配額車輛須為配額持有人在澳門註冊登記為私人用途的輕型客車，而為符合香港的法例要求，由首次登記日期起計車齡達六年或以上的車輛必須在每年辦理「過境車輛封閉道路通行許可證」及「國際通行許可證」前於澳門通過檢驗；配額持有人亦必須確保配額車輛於行駛港珠澳大橋時持有三地有效車輛強制保險。</li>" +
            "  <li>配額車輛和其指定駕駛員須遵守港澳相關法例規定。此外，由於大橋主橋位於內地司法管轄區，配額車輛及駕駛員在大橋主橋行駛時，須遵守內地法例及內地對來往港澳但不入境珠海車輛的規定。</li>" +
            "  <li>具備有效配額、香港運輸署發出的有效「過境車輛封閉道路通行許可證」（CRP）和「國際通行許可證」（ICP）、澳門海關發出的有效「車輛邊境通行證」和「車輛通關電子標籤」（RFID），以及內地發出的有效「臨時機動車駕駛許可」和「臨時入境機動車行駛證」及三地有效保險的配額車輛，可行駛港珠澳大橋往來港澳兩地，任何人或公司須自行對因其自身、內地或香港的原因導致其配額車輛未能經港珠澳大橋往來港澳兩地的情況及有關後果負責。</li>" +
            "  <li>在領取由香港運輸署發出的有效「過境車輛封閉道路通行許可證」（CRP）和「國際通行許可證」（ICP）前，須先完成辦理澳門海關的「車輛邊境通行證」和「車輛通關電子標籤」（RFID）申請。</li>" +
            "  <li>配額持有人、指定駕駛員或配額車輛如違反申領配額及港澳有關牌證的條款，其有關配額或牌證可被取消，其配額及牌證申請亦將不予受理。如配額、牌證或入境資格被取消，相應的配額及牌證亦可被取消。</li>" +
            "  <li>如內地根據內地規定取消有關車輛或申請人的入境資格，其相關配額及牌證可被取消，其配額及牌證申請亦將不予受理。</li>" +
            "  <li>同一配額持有人只可於同一期間持有私家車往來港澳的澳門配額或香港配額，若於同一期間被發現同時持有私家車往來港澳的澳門配額及香港配額，其配額可被取消，其日後的配額及牌證申請亦將不予受理。</li>" +
            "  <li>如發現配額持有人或指定駕駛員曾利用配額車輛進行走私、運送他人偷越邊境、非法營運（包括“白牌車”）、違規攜帶禁止或限制進出境物品、未申報應實施檢驗檢疫的行李或貨物等違法活動，該車輛相應的配額可被取消，而自查實確認之日起計三年內，配額持有人及行為人的配額及牌證申請亦將不予受理。</li>" +
            "  <li>如發現配額持有人曾以欺騙等不正當手段獲取港澳跨境私家車牌證，其配額可被取消，而自查實確認之日起計三年內，其配額及牌證申請將不予受理。</li>" +
            "  <li>申請人及配額持有人所填寫及提交的一切資料均須屬實，並無虛訛，否則其申請將不予受理或其配額可被取消，而自查實確認之日起計三年內，其申請將不予受理，以及可被追究相應的刑事責任。</li>" +
            "  <li>如配額車輛無正當理由逾期離港或無法離港，自離港或查實確認之日起計三年內，配額持有人及行為人的配額及牌證申請將不予受理。</li>" +
            "  <li>如發現配額車輛曾超出通行區、通行條件或並非由指定駕駛員駕駛，自查實確認之日起計一年，配額持有人及行為人的配額及牌證申請將不予受理。</li>" +
            "  <li>經澳門海關張貼在配額車輛的「車輛通關電子標籤」（RFID），在配額有效期間不得任意移除，違反者將可被視作超出通行條件處理。</li>" +
            "  <li>如發現2024年度配額車輛在未有遵循“澳車北上”的預約規則下進入內地，首次違反，該車輛相應的配額可被中止效力一個月，續後的每次違反，該車輛相應的配額可被中止效力三個月。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "2. 個人資料的保護" +
            "<br />" +
            "</p>" +
            "<ul>" +
            "  <li>作為本網站的擁有者，交通事務局（以下簡稱本局）保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，並得到妥為保存。個人資料會保存直至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀。</li>" +
            "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "3. 免責聲明" +
            "<br />" +
            "</p>" +
            "<ul>" +
            "  <li>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。交通事務局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。交通事務局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "4. 私隱條款" +
            "<br />" +
            "</p>" +
            "<ul>" +
            "  <li>繳費者於本系統所輸入之個人資料只會用於本系統及列印在電子收據上。</li>" +
            "  <li>為使使用者於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "5. 使用條款的改變" +
            "<br />" +
            "</p>" +
            "<ul>" +
            "  <li>若本使用條款有任何更新，我們會用新版本取代舊版本發佈，並在文件中列明更新修訂日期，但不作另行公佈。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "6. 聯絡方法" +
            "<br />" +
            "</p>" +
            "<ul>" +
            "  <li>地址：澳門馬交石炮台馬路33號地下 交通事務局（馬交石）服務專區</li>" +
            "  <li>辦公時間：星期一至星期五上午9時至下午6時(中午照常辦公)</li>" +
            "  <li>交通事務專線：(853) 8866 6363</li>" +
            "  <li>電郵：info@dsat.gov.mo</li>" +
            "</ul>",
        terms_body2: "<p>" +
            "  1. 注意事項：" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>配額持有人必須確保配額車輛於行駛港珠澳大橋時持有三地有效車輛強制保險。</li>" +
            "  <li>配額車輛和其指定駕駛員須遵守港澳相關法例規定。此外，由於大橋主橋位於內地司法管轄區，配額車輛及駕駛員在大橋主橋行駛時，須遵守內地法例及內地對來往港澳但不入境珠海車輛的規定。</li>" +
            "  <li>具備有效配額、香港運輸署發出的有效「過境車輛封閉道路通行許可證」（CRP）和「國際通行許可證」（ICP）（港澳跨境巴士及港澳跨境出租車則不需ICP）、澳門海關發出的有效「車輛邊境通行證」和「車輛通關電子標籤」（RFID），以及內地發出的有效「臨時機動車駕駛許可」和「臨時入境機動車行駛證」及三地有效保險的配額車輛，方可行駛港珠澳大橋往來港澳兩地，任何人或公司須自行對因其自身、內地或香港的原因導致其配額車輛未能經港珠澳大橋往來港澳兩地的情況及有關後果負責。</li>" +
            "  <li>配額持有人、指定駕駛員或配額車輛如違反申領配額及港澳有關牌證的條款，其有關配額或牌證可被取消，其配額或牌證申請亦將不予受理。如配額、牌證或入境資格被取消，相應的配額及牌證亦可被取消。</li>" +
            "  <li>如內地根據內地規定取消有關車輛或申請人的入境資格，其相關配額及牌證可被取消，其配額及牌證申請亦將不予受理。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  2. 個人資料的保護" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>作為本網站的擁有者，交通事務局（以下簡稱本局）保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，並得到妥為保存。個人資料會保存直至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀。</li>" +
            "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  3. 免責聲明" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。交通事務局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。交通事務局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  4. 私隱條款" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>繳費者於本系統所輸入之個人資料只會用於本系統及列印在電子收據上。</li>" +
            "  <li>為使使用者於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  5. 使用條款的改變" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>若本使用條款有任何更新，我們會用新版本取代舊版本發佈，並在文件中列明更新修訂日期，但不作另行公佈。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  6. 聯絡方法" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>地址：澳門馬交石炮台馬路33號地下 交通事務局（馬交石）服務專區</li>" +
            "  <li>辦公時間：星期一至星期五上午9時至下午6時(中午照常辦公)</li>" +
            "  <li>交通事務專線：(853) 8866 6363</li>" +
            "  <li>電郵：info@dsat.gov.mo</li>" +
            "</ul>",
        terms_body3: "<p>" +
            "  1. 網上繳付年度費用(續期)，注意事項：" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>需持有的士駕駛員證(電子卡)。</li>" +
            "  <li>需持有有效澳門居民身份證、澳門駕駛執照、澳門特別駕駛許可證。</li>" +
            "  <li>僅在清繳所有按第3/2019本號法律作出且已轉為不可申訴的決定所涉及的款項。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  2. 個人資料的保護" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>作為本網站的擁有者，交通事務局（以下簡稱本局）保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，並得到妥為保存。個人資料會保存直至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀。</li>" +
            "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  3. 免責聲明" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。交通事務局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。交通事務局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  4. 私隱條款" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>繳費者於本系統所輸入之個人資料只會用於本系統及列印在電子收據上。</li>" +
            "  <li>為使使用者於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  5. 使用條款的改變" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>若本使用條款有任何更新，我們會用新版本取代舊版本發佈，並在文件中列明更新修訂日期，但不作另行公佈。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  6. 聯絡方法" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>地址：澳門馬交石炮台馬路33號地下 交通事務局（馬交石）服務專區</li>" +
            "  <li>辦公時間：星期一至星期五上午9時至下午6時(中午照常辦公)</li>" +
            "  <li>交通事務專線：(853) 8866 6363</li>" +
            "  <li>電郵：info@dsat.gov.mo</li>" +
            "</ul>",
        terms_body4: "<p>" +
            "  1. 注意事項：" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>辦理網上申請國際駕駛執照服務的申請人必須為澳門駕駛執照之持有人，每次只可辦理一份國際駕駛執照申請；</li>" +
            "  <li>國際駕駛執照有效期依據澳門駕駛執照有效期簽發，但不超過一年；</li>" +
            "  <li>國際駕駛執照上可駕駛車輛種類依據澳門駕駛執照可駕駛之車輛種類發出；</li>" +
            "  <li>申請過程中須掃瞄由已獲准使用“網上數碼相片檢測平台服務”的攝影商號提供的“網上申請國際駕駛執照數碼相片回執”二維碼，且須確保相片於近6個月內拍攝（註：為免影響使用，本局可要求補交未符合條件的相片）；</li>" +
            "  <li>倘申請人有個人身份資料更改，需辦妥資料更新手續後再提交申請；</li>" +
            "  <li>倘有製作中或未領取之澳門駕駛執照或國際駕駛執照之服務記錄，不能使用網上申請服務，詳情請致電交通事務專線（88666363）查詢；</li>" +
            "  <li>短訊通知服務只適用於本地有效流動電話號碼；</li>" +
            "  <li>審批結果將以短信方式發送至已登記之本地流動電話號碼；</li>" +
            "  <li>申請人所填之資料將作為個人駕駛員檔案資料<sup>*註1</sup>。</li>" +
            "</ul>" +
            "<p></p>" +
            "<div><p>申請前請準備以下資料：" +
            "<div class='row'><span style='padding: 0 12px;'>-</span>有效澳門特區居民身份證；</div>" +
            "<div class='row'><span style='padding: 0 12px;'>-</span>澳門駕駛執照（有效期不少於一年）；</div>" +
            "<div class='row'><span style='padding: 0 12px;'>-</span>“網上申請國際駕駛執照數碼相片回執”二維碼（相片於近6個月內拍攝）；</div>" +
            "<div class='row'><span style='padding: 0 12px;'>-</span>可用於接收短信通知服務之登記本地流動電話號碼；</div>" +
            "<div class='row'><span style='padding: 0 12px;'>-</span>電郵地址（如需接收確認繳費通知）；</div>" +
            "</div></p>" +
            "<p>未能辦理網上服務的申請人，可前往交通事務局馬交石及中華廣場服務專區辦理有關申請，詳情請致電本局交通事務專線（88666363）查詢。</p>" +
            "<div style='color:red;'>《道路交通公約》的國家及地區一覽表：" +
            "<br /><a style='color: blue;' href='https://www.dsat.gov.mo/dsat/subpage.aspx?a_id=1443513686' title='《道路交通公約》的國家及地區一覽表' target='_blank'>https://www.dsat.gov.mo/dsat/subpage.aspx?a_id=1443513686</a>" +
            "</div>" +
            "<p></p>" +
            "<div class='row'><span>註1：</span>" +
            "<span style='flex:1;'>根據第17/93/M號法令核准的《道路交通規章》第七十條第四款的規定，駕駛員如更改居所，必須在六十日期限內通知交通事務局，違者可被罰款澳門元300元。交通事務局會根據表格內填報的住址及電話資料更新駕駛員檔案內的相關記錄。</span></div>" +
            "<p></p>" +
            "<p>" +
            "  2. 個人資料的保護" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>作為本網站的擁有者，交通事務局（以下簡稱本局）保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，並得到妥為保存。個人資料會保存直至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀。</li>" +
            "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  3. 免責聲明" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。交通事務局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。交通事務局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  4. 私隱條款" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>申請人於本系統所輸入之個人資料只會用於本系統及列印在電子收據上。</li>" +
            "  <li>為使使用者於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  5. 使用條款的改變" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>若本使用條款有任何更新，我們會用新版本取代舊版本發佈，並在文件中列明更新修訂日期，但不作另行公佈。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  6. 聯絡方法" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>地址：澳門馬交石炮台馬路33號地下 交通事務局（馬交石）服務專區</li>" +
            "  <li>辦公時間：星期一至星期五上午9時至下午6時(中午照常辦公)</li>" +
            "  <li>交通事務專線：(853) 8866 6363</li>" +
            "  <li>電郵：info@dsat.gov.mo</li>" +
            "</ul>",
        terms_body_hzmb_mo: "<p>" +
            "  1. 應遵事項：" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>每一配額均可配備不多於三名指定駕駛員，指定駕駛員須持有有效澳門居民身份證及由澳門當局發出的證明其具相關駕駛資格的澳門駕駛執照或特別駕駛許可證。公司配額指定駕駛員必須為公司的持有人或其屬下員工，並須提交有關的證明文件（如公司商業登記證明或由公司負責人簽名及公司蓋章的員工在職證明文件等）；個人配額申請人必須為指定駕駛員，但年齡達70歲或以上之申請人可無需作為指定駕駛員。</li>" +
            "  <li>如需更換使用配額的車輛（下稱“配額車輛＂）、車輛註冊號碼或駕駛員，每項資料的更改將收取費用（澳門元$1,000），不論在任何情況下，所有已支付的費用將不予退還。</li>" +
            "  <li>配額有效期內，有關公司不可一次或多次累計移轉該公司資本超過百分之五十，否則，將取消有關配額，但因繼承而作出移轉的情況則不在此限。</li>" +
            "  <li>不得連續超過180日處於未有向本局指定配額車輛或指定配額車輛被取消註冊的狀態，否則，將取消有關配額。</li>" +
            "  <li>配額不得轉讓，如車輛所有人在配額有效期內更改為另一所有人（配額持有人不再是配額車輛的所有人），以及2.3點所述情況，有關配額將會被取消。</li>" +
            "  <li>配額車輛須為配額持有人在澳門註冊登記為私人用途的輕型客車，而為符合香港的法例要求，由首次登記日期起計車齡達六年或以上的車輛必須在每年辦理「過境車輛封閉道路通行許可證」及「國際通行許可證」前於澳門通過檢驗；配額持有人亦必須確保配額車輛於行駛港珠澳大橋時持有三地有效車輛強制保險。</li>" +
            "  <li>配額車輛和其指定駕駛員須遵守港澳相關法例規定。此外，由於大橋主橋位於內地司法管轄區，配額車輛及駕駛員在大橋主橋行駛時，須遵守內地法例及內地對來往港澳但不入境珠海車輛的規定。</li>" +
            "  <li>具備有效配額、香港運輸署發出的有效「過境車輛封閉道路通行許可證」（CRP）和「國際通行許可證」（ICP）、澳門海關發出的有效「車輛邊境通行證」和「車輛通關電子標籤」（RFID），以及內地發出的有效「臨時機動車駕駛許可」和「臨時入境機動車行駛證」及三地有效保險的配額車輛，可行駛港珠澳大橋往來港澳兩地，任何人或公司須自行對因其自身、內地或香港的原因導致其配額車輛未能經港珠澳大橋往來港澳兩地的情況及有關後果負責。</li>" +
            "  <li>配額持有人、指定駕駛員或配額車輛如違反申領配額及港澳有關牌證的條款，其有關配額或牌證可被取消，其配額或牌證申請亦將不予受理。如配額、牌證或入境資格被取消，相應的配額及牌證亦可被取消。</li>" +
            "  <li>如內地根據內地規定取消有關車輛或申請人的入境資格，其相關配額及牌證可被取消，其配額及牌證申請亦將不予受理。</li>" +
            "  <li>同一配額持有人只可於同一期間持有私家車往來港澳的澳門配額或香港配額，若於同一期間被發現同時持有私家車往來港澳的澳門配額及香港配額，其配額可被取消，其日後的配額及牌證申請亦將不予受理。</li>" +
            "  <li>如發現配額持有人及指定駕駛員曾利用配額車輛進行走私、運送他人偷越邊境、非法營運（包括“白牌車”）、違規攜帶禁止或限制進出境物品、未申報應實施檢驗檢疫的行李或貨物等違法活動，該車輛相應的配額可被取消，而自查實確認之日起計三年內，配額持有人及行為人的配額及牌證申請亦將不予受理。</li>" +
            "  <li>如發現配額持有人曾以欺騙等不正當手段獲取港澳跨境私家車牌證，其配額可被取消，而自查實確認之日起計三年內，其配額及牌證申請將不予受理。</li>" +
            "  <li>申請人及配額持有人所填寫及提交的一切資料均須屬實，並無虛訛，否則其申請將不予受理或其配額可被取消，而自查實確認之日起計三年內，其申請將不予受理，以及可被追究相應的刑事責任。</li>" +
            "  <li>如配額車輛無正當理由逾期離港或無法離港，自離港或查實確認之日起計三年內，配額持有人及行為人的配額及牌證申請將不予受理。</li>" +
            "  <li>如發現配額車輛曾超出通行區、通行條件或由非指定駕駛員駕駛，自查實確認之日起計一年，配額持有人及行為人的配額及牌證申請將不予受理。</li>" +
            "  <li>經澳門海關張貼在配額車輛的「車輛通關電子標籤」（RFID），在配額有效期間不得任意移除，違反者將可被視作超出通行條件處理。</li>" +
            "  <li>如發現配額車輛在未有遵循“澳車北上”的預約規則下進入內地，首次違反，該車輛相應的配額可被中止效力一個月，續後的每次違反，該車輛相應的配額可被中止效力三個月。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  2. 個人資料的保護" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>作為本網站的擁有者，交通事務局（以下簡稱本局）保證本局工作人員均遵守所有的相關規定，你的個人資料處理會受到保密措施規範，並得到妥為保存。個人資料會保存直至該等資料無須再用於收集時所作的用途，或到政府規定的保存期限，屆時這些資料將按有關規定銷毀。</li>" +
            "  <li>你有權向本局查閱及修改保存於本網站上的你的個人資料，或向接收本局之轉交並保存這些資料的其他政府部門查閱及修改保存於該局網站上的你的個人資料。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  3. 免責聲明" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>本網站已盡力確保內容準確，但並不對該等內容作出任何明示或隱含的保證及承諾，所有資料以「現狀」提供，不負任何責任。交通事務局也保留權利隨時刪除、暫時停載或編輯本網址上的各項資料而無須事先通知。交通事務局不對因為使用網站的資料而引致的任何損害或損失負任何責任或作任何賠償。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  4. 私隱條款" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>繳費者於本系統所輸入之個人資料只會用於本系統及列印在電子收據上。</li>" +
            "  <li>為使使用者於本網頁所輸入的資料保密，本服務使用加密套接協議層(SSL)。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  5. 使用條款的改變" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>若本使用條款有任何更新，我們會用新版本取代舊版本發佈，並在文件中列明更新修訂日期，但不作另行公佈。</li>" +
            "</ul>" +
            "<p></p>" +
            "<p>" +
            "  6. 聯絡方法" +
            "  <br />" +
            "</p>" +
            "<ul>" +
            "  <li>地址：澳門馬交石炮台馬路33號地下 交通事務局（馬交石）服務專區</li>" +
            "  <li>辦公時間：星期一至星期五上午9時至下午6時(中午照常辦公)</li>" +
            "  <li>交通事務專線：(853) 8866 6363</li>" +
            "  <li>電郵：info@dsat.gov.mo</li>" +
            "</ul>",
    },
    ...school_zhTw,
    ...hzmbG_zhTw,
    ...HzmbH_zhTw,
    ...HzmbChange_zhTw,
    ...twLocale,
}

export default ZH_TW